import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

import { cardSizeMobileStyles, cardSizeStyles } from '../styles';

export const WIDE_CARD_IMAGE_HEIGHT = 16.2;
export const WIDE_CARD_IMAGE_WIDTH = 13.7;
export const WIDE_CARD_MOBILE_IMAGE_HEIGHT = 10.6;
export const WIDE_CARD_MOBILE_IMAGE_WIDTH = 8;

const WIDE_CARD_SIZE = {
  maxHeight: 20.4,
  width: 57.3,
};

export const WIDE_CARD_SIZE_MOBILE = {
  width: '100%',
};

export const wideCardSizeStyles = cn(
  cardSizeStyles(WIDE_CARD_SIZE),
  cardSizeMobileStyles(WIDE_CARD_SIZE_MOBILE),
);

export const grayscaleStyles = css`
  filter: grayscale(1);
  opacity: 0.75;
`;
